// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"736":"ac40780b","977":"4e171c34"}[chunkId] + ".chunk.css";
};